// extracted by mini-css-extract-plugin
export default {"btn":"TripContainer_btn__xZ7sE"};